<div class="w-full">
  <!--BLUE BAR-->
  <div class="horiz-bar bg-primary"></div>

  <!--TITLE & DROPDOWN-->
  <div class="flex justify-content-between align-items-center flex-wrap mb-4 mt-4">
    <div class="flex justify-content-between align-items-center">
      <div class="text-800 text-3xl font-medium mr-4">{{"POPULATION_COMPARISON"|translate}}</div>
      <p-button label="References" [outlined]="true" severity="secondary" size="small" class="ml-2"
        styleClass="text-xs px-3 py-1 border-gray-300 text-gray-600 hover:bg-gray-50" (onClick)="showReferences()">
      </p-button>
    </div>
    <p-dropdown [options]="dataSets" [(ngModel)]="selectedDataset" placeholder="Language" optionLabel="label"
      (onChange)="onDatasetChanged($event)">
    </p-dropdown>
  </div>
  <!--DISCLAIMER-->
  @if (reportType == ReportType.ECP) {
  <div class="mb-4 text-gray-400 text-sm">*{{'POPULATION_COMPARISON_DISCLAIMER'|translate}}</div>
  }
  <!--GREY BAR-->
  <div class="horiz-bar-thin bg-gray-200"></div>
  <!--SER PERCENTILE & GRAPH-->
  <app-ser-percentile [serCalcResponse]="serCalcResponse" [ethnicity]="ethnicity"
    [treatmentCalcResponse]="treatmentCalcResponse"></app-ser-percentile>
  <!--GREY BAR-->
  <div class="horiz-bar-thin bg-gray-200 mt-4 mb-4"></div>
  <!--AXIAL PERCENTILE & GRAPH-->
  <app-axial-percentile [axialCalcResponse]="axialCalcResponse" [treatmentCalcResponse]="treatmentCalcResponse"
    [ethnicity]="ethnicity"></app-axial-percentile>
  <app-parent-paragraph *ngIf="reportType === ReportType.Parent" [personalization]="personalization" [retestMonths]="6"
    [parentParagraphType]="ParentParagraphType.HOW_DO_MY_CHILDS_RESULTS_COMPARE_PREMYOPE"></app-parent-paragraph>

  <!-- References Dialog -->
  <p-dialog header="🔬 Scientific References" [(visible)]="showReferencesDialog" [modal]="true"
    [style]="{width: '50vw'}" [draggable]="false" [resizable]="false" (onHide)="hideReferences()">
    <app-references></app-references>
  </p-dialog>
</div>